import React from 'react';
import { ApButtonGroup, ApButtonDanger } from '@alixpartners/ui-components';
import {
	Wrapper,
	StyledButtonSecondary,
	StyledModal,
} from '../../Details/ChangeTypeModal/styles';
import { ModalText } from './Bin.styles';

export const DeleteForeverModal = ({
	confirmDelete,
	onClose,
	transactionsAmount,
}) => {
	return (
		<Wrapper onClick={e => e.stopPropagation()}>
			<StyledModal
				isOpen
				header="Delete forever"
				isDismissible
				hasClosed={onClose}
				footer={({ handleClose }) => {
					return (
						<ApButtonGroup justifyContent="flex-end">
							<StyledButtonSecondary onClick={handleClose}>
								Cancel
							</StyledButtonSecondary>
							<ApButtonDanger onClick={confirmDelete}>
								delete forever
							</ApButtonDanger>
						</ApButtonGroup>
					);
				}}
			>
				<ModalText>
					You are about to permanently delete {transactionsAmount} transaction{transactionsAmount >
					1
						? 's'
						: ''}. Are you sure you want to proceed?
				</ModalText>
			</StyledModal>
		</Wrapper>
	);
};

export default DeleteForeverModal;
